export enum ENVIRONMENT {
  LOCAL = 'local',
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
}

export const getEnvironment = (): string => {
  return process.env.NODE_ENV && process.env.NODE_ENV !== 'test'
    ? process.env.NODE_ENV
    : ENVIRONMENT.LOCAL;
};
